class FormGroup {
  constructor(elm, id) {
    this.id = id;
    const storageStr = localStorage.getItem(`formGroupOpen[${this.id}]`);

    this.elm = elm;
    this.open = (() => {
      if (!storageStr) return false;
      return storageStr === "true";
    })();
    this.$head = this.elm.querySelectorAll(".js-head")[0];
    this.$body = this.elm.querySelectorAll(".js-body")[0];
    this.$firstInput = this.$body.querySelectorAll("input")[0];
    this.$inputs = gsap.utils
      .toArray(this.$body.querySelectorAll("input"))
      .filter((elm, index) => {
        return index > 0;
      });

    if (this.open) {
      this.$head.classList.add("-active");
      gsap.set(this.$body, {
        height: "auto",
      });
    }

    this.isCheckAll = () => {
      return this.$inputs.every((elm) => elm.checked);
    };

    // 開閉
    this.$head.addEventListener("click", () => {
      this.$head.classList.toggle("-active");
      gsap.to(this.$body, 0.5, {
        height: this.open ? 0 : "auto",
        ease: "power4.inOut",
        onComplete: () => {
          this.open = !this.open;
          localStorage.setItem(`formGroupOpen[${this.id}]`, this.open);
        },
      });
    });

    // すべてチェック
    this.$firstInput.addEventListener("change", () => {
      gsap.utils.toArray(this.$inputs).forEach((elm) => {
        elm.checked = this.$firstInput.checked;
      });
    });

    // すべてチェックを解除
    gsap.utils.toArray(this.$inputs).forEach((elm) => {
      elm.addEventListener("change", () => {
        this.$firstInput.indeterminate = true;
        if (!this.isCheckAll()) {
          this.$firstInput.checked = false;
        }
      });
    });
  }
}

const init = () => {
  gsap.utils.toArray(".js-form-group").forEach((elm, index) => {
    new FormGroup(elm, index);
  });
};

export { init };
